import moment from 'moment'
import { usesLegacyStamp, stampHeading } from '../../../shared/contract-stamp'

// MYS-7313: the confirmation stamp of a signed contract is frozen at signing time via
// contract.signatureVersion. Version and heading rules live in shared/contract-stamp.ts and
// are the same ones the api2 PDF renderer uses; this module only adds the dashboard's
// client-side date formatting for the "signed on …" sentence.
export { usesLegacyStamp, stampHeading }

/**
 * The "signed on …" sentence (HTML, bold parts as in the cards).
 * `t` translates a bare key, e.g. key => this.$t('text.' + key).
 */
export function signedInfoText(contract, t) {
	const date = moment(contract.signedDate).format('DD.MM.YYYY')
	const time = moment(contract.signedDate).format('HH:mm:ss')
	const person = `<b>${contract.signatureName}, ${contract.signaturePosition}</b>`
	if (usesLegacyStamp(contract)) {
		return `${t('signedOn')} <b>${date} ${t('at')} ${time}</b> ${t('by')} ${person}`
	}
	return `${t('signedOn')} <b>${date} ${t('at')} ${time}</b> ${t('signedByCompany')} <b>${contract.serviceProviderName || ''}</b> ${t('throughAuthorisedPerson')} ${person}`
}
